export default __webpack_public_path__ + "static/media/step.094b7040.svg";